module.exports = __webpack_public_path__ + "img/logo.fe118575.png";